import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import commonPl from "./locales/pl/common.json";
import jobOfferPl from "./locales/pl/jobOffer.json";
import loginPl from "./locales/pl/login.json";
import modelsPl from "./locales/pl/models.json";
import accountPl from "./locales/pl/account.json";
import homePl from "./locales/pl/home.json";
import subscriptionsPl from "./locales/pl/subscriptions.json";
import chatPl from "./locales/pl/chat.json";
import commonEn from "./locales/en/common.json";
import jobOfferEn from "./locales/en/jobOffer.json";
import loginEn from "./locales/en/login.json";
import modelsEn from "./locales/en/models.json";
import accountEn from "./locales/en/account.json";
import homeEn from "./locales/en/home.json";
import subscriptionsEn from "./locales/en/subscriptions.json";
import chatEn from "./locales/en/chat.json";
import commonDe from "./locales/de/common.json";
import jobOfferDe from "./locales/de/jobOffer.json";
import loginDe from "./locales/de/login.json";
import modelsDe from "./locales/de/models.json";
import accountDe from "./locales/de/account.json";
import homeDe from "./locales/de/home.json";
import subscriptionsDe from "./locales/de/subscriptions.json";
import chatDe from "./locales/de/chat.json";

export const SUPPORTED_LANGUAGES = ["pl-PL", "en-US", "de-DE"];

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            "pl-PL": {common: commonPl, jobOffer: jobOfferPl, login: loginPl, models: modelsPl, account: accountPl, home: homePl, subscriptions: subscriptionsPl, chat: chatPl},
            "en-US": {common: commonEn, jobOffer: jobOfferEn, login: loginEn, models: modelsEn, account: accountEn, home: homeEn, subscriptions: subscriptionsEn, chat: chatEn},
            "de-DE": {common: commonDe, jobOffer: jobOfferDe, login: loginDe, models: modelsDe, account: accountDe, home: homeDe, subscriptions: subscriptionsDe, chat: chatDe},
        },
        fallbackLng: "pl-PL",
        supportedLngs: SUPPORTED_LANGUAGES,
        ns: ["common", "jobOffer", "login", "models", "account", "home", "subscriptions", "chat"],
        defaultNS: "common",
        interpolation: {escapeValue: false},
        detection: {
            order: ["localStorage", "navigator"],
            caches: ["localStorage"],
            lookupLocalStorage: "cyberjob_language",
        },
    });

export default i18n;
